<div [@.disabled]="disableAnimation" class="my-container" [@trigger] *ngIf="show" (@trigger.done)="animationCallback($event)">
  <div class="balloon hide-on-desktop-down is-flex has-flex-content-center">
    <img class="img" src="{{'/assets/BalloonLarge.svg' | staticp}}" alt="agent-profile-picture">
  </div>
  <div id="login-label-myReMax" class="text-center top-wrapper is-flex has-flex-content-center">
    <span class="my-remax-title red">MY RE</span>
    <span class="my-remax-title">/</span>
    <span class="my-remax-title red">MAX</span>
    <a (click)="close()">
      <i class="material-icons has-pos-abs back-action">close</i>
    </a>
  </div>

  <app-sign-in #signIn *ngIf="showSignIn" (continueWithSocialLogin)="continueLogin($event)" (showForgotPassword)="forgotPassword($event)" [email]="email"></app-sign-in>
  <app-forgot-password *ngIf="showForgotPassword" (showForgotPassword)="forgotPassword($event)" [email]="email"></app-forgot-password>
</div>
